import { render, staticRenderFns } from "./DraggableComponent.vue?vue&type=template&id=e245a09e"
import script from "./DraggableComponent.vue?vue&type=script&lang=js"
export * from "./DraggableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports